import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs/internal/Observable';
import { STORE_FEATURE_KEY_BLOCK_TIMES_PROXIMITY } from './block-times-proximity.reducer';

const getProximity = (appState: any) => appState[STORE_FEATURE_KEY_BLOCK_TIMES_PROXIMITY].proximity;
const getBlockTimes = (appState: any) => appState[STORE_FEATURE_KEY_BLOCK_TIMES_PROXIMITY].blockTimes;
const getIsCancelled = (appState: any) => appState[STORE_FEATURE_KEY_BLOCK_TIMES_PROXIMITY].isCancelled;

@Injectable()
export class BlockTimesProximitySelectors {
    constructor(private store: Store<any>) {
    }

    selectGetBlockTimes(): Observable<any> {
        return this.store
            .pipe(select(getBlockTimes));
    }

    selectGetProximity(): Observable<any> {
        return this.store
            .pipe(select(getProximity));
    }

    selectIsCancelled(): Observable<boolean> {
        return this.store
            .pipe(select(getIsCancelled));
    }
}
